var map = {
	"./saffronfiles/assets/static/core/images/boxy/default-background.webp": "3279",
	"./saffronfiles/assets/static/core/images/index.html": "65a1",
	"./saffronfiles/assets/static/core/images/logos/main.png": "0f5d",
	"./saffronfiles/assets/static/core/images/logos/main.svg": "2aa4",
	"./saffronfiles/assets/static/core/images/user/login/boxy_background_2.jpg": "34b4",
	"./saffronfiles/assets/static/core/images/user/login/boxy_background_3.jpg": "09e6",
	"./saffronfiles/assets/static/core/index.html": "77a1",
	"./saffronfiles/assets/static/images/backgrounds/boxy-default.webp": "66ce",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-2.jpg": "6146",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-3.jpg": "b1b4",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-4.jpg": "6f5f",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-5.jpg": "b13b",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-small.png": "cf15",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-small.webp": "0539",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg.jpg": "c676",
	"./saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg.png": "6a06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a6dd";